export default __webpack_public_path__ + "static/media/close-btn.2d7410f2.svg";